import React, { useEffect, useRef } from "react";
// import { CSSTransition } from "react-transition-group";
import useWebview from "../../../../hooks/useWebview";
import Footer from "../Footer";
import Header from "../Header";

type ThemeType = "light" | "dark";

interface PageProps {
  isHeaderOverlay?: boolean;
  theme?: ThemeType | { desktop: ThemeType; mobile: ThemeType };
  loaded?: boolean;
  grid?: boolean;
  headerCTA?: React.ReactNode;
  isStickyHeader?: boolean;
  isStickyHeaderMobile?: boolean;
}

const Page: React.FC<PageProps> = ({
  children,
  isHeaderOverlay = false,
  theme = "light",
  loaded = true,
  grid,
  isStickyHeader = true,
  isStickyHeaderMobile = true,
  headerCTA,
}) => {
  const pageRef = useRef<HTMLElement>(null);
  const { inWebview } = useWebview();
  const isSticky = window.innerWidth > 768 && isStickyHeader;
  const isStickyMobile = window.innerWidth < 768 && isStickyHeaderMobile;

  useEffect(() => {
    const { hash } = window.location;
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element)
        setTimeout(() => {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }, 1000);
    }
  }, []);

  return (
    <section
      className={`flex flex-col w-screen max-w-full min-h-screen ${
        grid && window.innerWidth < 768 ? "bg-gray-200" : "bg-white"
      }`}
    >
      {typeof theme === "string" ? (
        !inWebview && (
          <Header
            absolute={isHeaderOverlay}
            sticky={isSticky}
            theme={theme}
            isStickyMobile={isStickyMobile}
            headerCTA={headerCTA}
          />
        )
      ) : (
        <>
          <div className="w-full sm:hidden">
            {!inWebview && (
              <Header
                absolute={isHeaderOverlay}
                sticky={isSticky}
                theme={theme.mobile}
                isStickyMobile={isStickyMobile}
                headerCTA={headerCTA}
              />
            )}
          </div>
          <div className="hidden w-full sm:block">
            {!inWebview && (
              <Header
                absolute={isHeaderOverlay}
                sticky={isSticky}
                isStickyMobile={isStickyMobile}
                theme={theme.desktop}
                headerCTA={headerCTA}
              />
            )}
          </div>
        </>
      )}
      <section className="flex-grow w-full" ref={pageRef}>
        {children}
      </section>
      {!inWebview && <Footer />}
    </section>
  );
};

export default Page;
